<template>
  <div id="bottom-bar">
    <div id="header" class="sticky-top border-bottom" style="z-index: 9;">
      <div class="container-fluid px-3 px-md-4 bottom-bar-shell">
        <div class="row justify-content-between align-items-center">
          <div class="col-8 col-md-6">
            <router-link to="/pedidos" class="text-decoration-none" title="Acessar Pedidos">
              <div class="d-flex align-items-center app-profile">
                <div class="mr-3 app-avatar">
                  <div class="app-logo" aria-hidden="true"></div>
                </div>
                <div>
                  <h2 class="title">{{empresa.nome}}</h2>
                  <div class="small status-pill status-pill-warning" v-if="!geoLocation">
                    <i class="fa-solid fa-triangle-exclamation mr-1"></i> Localização
                  </div>
                  <div class="small status-pill" :class="online ? 'status-pill-online' : 'status-pill-offline'" v-else>
                    <i class="fa-solid fa-circle mr-1" :class="{'animated flash slower infinite': online}"></i>{{ online ? 'Online' : 'Offline' }}
                  </div>
                </div>
              </div>
            </router-link>
          </div>
          <div class="col-4 col-md-6 d-flex justify-content-end align-items-center">
            <div class="mr-2">
              <router-link to="/historico" class="btn quick-action" title="Minhas Entregas">
                <i class="fa-solid fa-receipt"></i>
                <div class="quick-action__label"><b>Entregas</b></div>
              </router-link>
            </div>
            <div>
              <router-link to="/configs" class="btn quick-action" title="Configurações">
                <i class="fa-solid fa-sliders"></i>
                <div class="quick-action__label"><b>Configs</b></div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BottonBar',
  computed: {
    empresa() {
      return this.$store.state.user;
    },

    online() {
      return this.$store.state.online;
    },

    geoLocation() {
      return this.$store.state.geoLocation;
    }
  },
}
</script>
<style scoped>
#header {
  padding-top: var(--safe-area-inset-top, env(safe-area-inset-top, 0));
  padding-bottom: 0;
  background-color: rgba(247, 248, 245, 0.82);
}

.bottom-bar-shell {
  padding-top: 12px;
  padding-bottom: 12px;
}

.app-profile {
  padding: 6px 0;
}

.app-avatar {
  width: 54px;
  height: 54px;
  border-radius: 18px;
  background: var(--primary);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(199, 244, 123, 0.55);
  box-shadow: 0 10px 22px rgba(199, 244, 123, 0.18);
}

.app-logo {
  width: 32px;
  height: 32px;
  background-color: #ffffff;
  -webkit-mask: url("../assets/logo.svg") center / contain no-repeat;
  mask: url("../assets/logo.svg") center / contain no-repeat;
}

.title {
  font-size: 1rem;
  margin-bottom: 0;
  line-height: 1.1rem;
  font-weight: 600;
}

.status-pill {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  margin-top: 6px;
  border-radius: 999px;
  background-color: var(--secondary);
  border: 1px solid var(--border-color);
  color: var(--text-muted);
}

.status-pill-online {
  background-color: #ffffff;
}

.dark-mode .status-pill-online {
  background-color: var(--secondary);
}

.status-pill-online {
  color: var(--text-default);
}

.status-pill-online i {
  color: var(--primary);
}

.status-pill-warning,
.status-pill-offline {
  color: var(--text-muted);
}

.quick-action {
  width: 72px;
  min-height: 72px;
  padding: 10px 8px;
  border-radius: 22px;
  background-color: var(--bg-theme-secondary);
  border: 1px solid var(--border-color);
  color: var(--text-default);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.quick-action__label {
  font-size: 0.64rem;
  line-height: 0.8rem;
}

.quick-action.router-link-exact-active {
  background-color: rgba(199, 244, 123, 0.2);
  border-color: rgba(199, 244, 123, 0.45);
  color: var(--text-default);
}

.dark-mode #header {
  background-color: rgba(15, 17, 16, 0.84);
}
</style>
